const addIcon = 'iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAYAAAA7bUf6AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABmSURBVHgB7ZGxDYAwDATfAYm1sglsAXSMwiaEGUCihS3SYMMCxkgIpclJrny65gGLdvGW4iwBRNP3yAty5KcIod9qyNk8OP6+oBeKsQTHGa7aVUk4gNyg/jkeMOlWsZQ8ccJIsIQLenUU3MUaF1QAAAAASUVORK5CYII=';
const deleteIcon = 'iVBORw0KGgoAAAANSUhEUgAAAA8AAAARCAYAAAACCvahAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAFkSURBVHgBrVNLTgJBEH3VA9HEBXMDZ2s0Bm/gDeQGxhMoCwO4AXewkhvIDYgnAE8wakC3ww1wpwJdVk8zH5wJw8KXTFJTXa9f9atuQh7uJlUwHuWrAjTA108d/bP53zKVIbZ9F5qG0BiD1DmIq9gvD/M0CK23Gli5Sco5BFYdCa7sv5CZLqWyvsFkZ0xoTkayYNo0bQUoQlRL6NhEazpEc9rGLmhNfDSmFya0Zw5V2cNu8KBonpBNu0xuavcHNN6vY6VbcT8Cw8VSf6bIPNtQNhsRu3FcUpUwbnzYmsUiSMikjQEuCrH0wiOuZ74mqyA8SxGUdEOIL4slrxybuPG3q1NJ7kAyTkvuHdnEwV5lK1mLMlOsXEptG2DJxlUxb/Us1zMqGkB/z9axJw4GWTJxYlr3dBDnu8f3iYBMhGicr6xRk5m+Qi0yL0hKPakxbr9kyVqeHZVHcOADZeSCuY/eyRP+A785YXvq68aweQAAAABJRU5ErkJggg==';

export const getImageExperienceStyles = () => ({
  '@global': {
    '.add-media-panel-crud-ad': {
      '& .asset-library-new-feature-banner': {
        display: 'none',
      },

      '& .asset-library-page-header': {
        display: 'none',
      },
      '& .media-sources-and-upload-container': {
        '@media (max-width:600px)': {
          flexDirection: 'column',
        },
      },
      '& .file-default-wrapper': {
        '@media (max-width:600px)': {
          paddingTop: 5,
          paddingLeft: 16,
        },
      },
    },
    '.media-editor-rails-root': {
      '@media (max-width:600px)': {
        flexDirection: 'column',
        '& .left-rail-root': {
          minWidth: 300,
          width: '100%',
        },
        '& .right-rail-root': {
          left: 0,
          width: '100%',
        },
        '& .cropped-image-view': {
          width: '100% !important',
          '& img': {
            width: '100% !important',
          },
        },
      },
    },
  },
  imageListContainer: {
    marginBottom: '8px',

    '& .image-list-content .ms-Label': {
      display: 'none',
    },

    '& .ms-ChoiceFieldGroup-flexContainer': {
      gap: '8px',
      marginBottom: '8px',

      '& .ms-ChoiceField': {
        margin: '0px',
        background: 'none',
        border: 'none',

        '& .ms-ChoiceField-input': {
          bottom: '0px',
          left: '0px',
        },
      },

      '& .image-list-item': {
        width: '114px',
        height: '94px',
        borderRadius: '6px',
        overflow: 'hidden',

        '& .ms-ChoiceField-field': {
          width: '114px',
          height: '94px',
          padding: '0px',
          margin: '0px',
          borderWidth: '2px',
          borderRadius: '6px',
          boxSizing: 'border-box',

          '&.is-checked::after': {
            content: ({ previewLabel }) => `"${previewLabel}"`,
            display: 'block',
            width: 'fit-content',
            height: '20px',
            top: 'auto',
            bottom: '8px',
            left: '8px',
            borderRadius: '4px',
            fontSize: '12px',
            lineHeight: '10px',
            color: 'white',
            transition: 'none',
          },
        },
        '& .ms-ChoiceField-innerField': {
          padding: '0px',
        },
        '& .ms-ChoiceField-labelWrapper': {
          display: 'none',
        },

        '& .image-delete': {
          position: 'absolute',
          top: '4px',
          right: '4px',
          width: '27px',
          height: '27px',
          backgroundColor: 'rgba(255, 255, 255, 0.66)',
          border: 'none',
          borderRadius: '2px',

          '&::before': {
            content: '""',
            display: 'block',
            width: '16px',
            height: '26px',
            backgroundImage: `url("data:image/png;base64,${deleteIcon}")`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
          },
        },
        '& .image-edit': {
          display: 'none',
        },
      },
    },

    '& .image-list-add-placeholder': {
      background: 'none',
      border: '1px dashed #C8C6C4',
      color: '#0078D4',

      '& .ms-ChoiceField-field': {
        display: 'none',
      },

      '& .image-add::before': {
        display: 'block',
        width: '32px',
        height: '32px',
        content: '""',
        backgroundImage: `url("data:image/png;base64,${addIcon}")`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
      },
    },

    '& .remove-all-button': {
      display: 'none',
    },
  },
});
